import {
    Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, Grid, Paper,
    styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
    TableHead, TableRow, TextField
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import Home from '../home/Home';
import BillingService from '../../Services/billing/BillingService';
import Snacbar from '../Snacbar';
import { getUserId } from '../Utils/Common';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';
import BillingReportsService from '../../Services/Reports/BillingReportsService';

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder',
}

const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '400px'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    maxHeight: '200',
    height: '100%',
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));
const ItemPap3 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));
const ItemPap4 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
        color: 'black',
        textAlign: 'center',
        maxHeight: '30px',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        color: 'darkblue',
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));
function FirstLevelBill(props) {

    const [OpenQuotation, setOpenQuotation] = useState(false);
    const [OpenQuotationPreview, setOpenQuotationPreview] = useState(false);
    const [OpenViewJob, setOpenViewJob] = useState(false);
    const [OpenOverAllViewJob, setOpenOverAllViewJob] = useState(false);
    const [OpenJobBillVerified, setOpenJobBillVerified] = useState(false);
    const [radiovalues, setradiovalues] = useState('1');
    const [quatetionId, setQuatetionId] = useState('');
    const [selected, setSelected] = useState([]);
    const [selected2, setSelected2] = useState([]);
    const [nonUplode, setnonUplode] = useState([]);
    const [Filtereddetails, setFiltereddetails] = useState([]);

    const [DrpImporter, setDrpImporter] = useState([]);
    const [billName, setbillName] = useState([]);
    const [billType, setbillType] = useState([]);
    const [billPrintType, setBillPrintType] = useState([]);
    const [VoucherType, setVoucherType] = useState([]);
    const [Brannch, setBrannch] = useState([]);
    const [PrintedType, setPrintedType] = useState([]);

    const [BillingQuotationDetails, setBillingQuotationDetails] = useState([]);
    const [BillingCustodian, setBillingCustodian] = useState([]);
    const [PaymentReqPurpose, setPaymentReqPurpose] = useState([]);
    const [AllPayment, setAllPayment] = useState([]);
    const [BillingCustom, setBillingCustom] = useState([]);
    const [BillingSummary, setBillingSummary] = useState([]);
    const [QuotationBasedOnCustomerType, setQuotationBasedOnCustomerType] = useState([]);

    const [open, setOpen] = useState(false);
    const [severity, setseverity] = useState('');
    const [message, setMessage] = useState('');

    const [FirstLevelBillValues, setFirstLevelBillValues] = useState({
        billid: '', FirstLvl_importer: '', FirstLvl_jobNo: '', FirstLvl_Billname: '', FirstLvl_BillPrintType:'',FirstLvl_BillPayby: '', FirstLvl_BillPayDate: '', FirstLvl_BillPaidto: '',
        FirstLvl_Paymenttype: '', FirstLvl_vouchertype: '', FirstLvl_printedtype: '', FirstLvl_RecVoucherNo: '', FirstLvl_BillAmount: '', FirstLvl_Remraks: '', FirstLvl_gstpercnt: '',
        commercial_invoiceNo: '', generalDesc: '', noofpkgs: '', containerNo: '', besbNo: '', besbDate: '', mawbNo: '', mawbDate: '', hawbNo: '', hawbDate: '', operationType: '',
        accessablevalue: '', grossweight: '', branch: '', importername: '', forwardername: '', servicetype: '', importeriecNo: '', forwarderiecNo: '', Gatewayport: '', disablejobno: '',
    });
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    });
    const [consigmnt, setConsigment] = useState('');
    const [dialogValues, setDialogValues] = useState({
        grossWight: '',
        chargeableWight: ''
    })
    const [BillGenError, setBillGenError] = useState({
        FirstLvl_Billname: false, FirstLvl_BillPayby: false, FirstLvl_Paymenttype: false, FirstLvl_vouchertype: false,
        FirstLvl_printedtype: false, FirstLvl_RecVoucherNo: false, FirstLvl_BillAmount: false,
    })
    const [Error, setError] = useState({
        txt_accValue: false, dat_besbDate: false, txt_besbno: false
    })

    const [quatetion, setquatetion] = useState('');
    const [expensis, setexpensis] = useState('');
    const [actualExpensis, setactualExpensis] = useState('');
    const [requestEstimetion, setrequestEstimetion] = useState('');
    const [loading, setloading] = useState(false)
    const [UpdateDsa, setUpdateDsa] = useState(true);
    const [DeleteDsa, setDeleteDsa] = useState(true);

    const [Update, setUpdate] = useState(false);
    const [Delete, setDelete] = useState(false);

    const [QuateUpdateDsa, setQuateUpdateDsa] = useState(false);

    const [QuateUpdate, setQuateUpdate] = useState(false);

    //onClick
    const searchkeydown = (e) => {
        if (e.key === 'Enter') {
            getJobNoConsoleNonUpload(FirstLevelBillValues.FirstLvl_importer, FirstLevelBillValues.FirstLvl_jobNo);
        }
    }
    const validate = () => {
        if (FirstLevelBillValues.FirstLvl_Billname !== '') {
            if (FirstLevelBillValues.FirstLvl_BillPayby !== '') {
                if (FirstLevelBillValues.FirstLvl_Paymenttype !== '') {
                    if (FirstLevelBillValues.FirstLvl_vouchertype !== '') {
                        if (FirstLevelBillValues.FirstLvl_printedtype !== '') {
                            if (FirstLevelBillValues.FirstLvl_BillAmount !== '') {
                                return true;
                            }
                            else {
                                document.getElementById('billAmount').focus();
                                setBillGenError({ ...BillGenError, FirstLvl_BillAmount: true });
                                setOpen(true); setseverity('warning'); setMessage('Please Enter Billing Amount ..!!');
                            }
                        }
                        else {
                            document.getElementById('printedTyp').focus();
                            setBillGenError({ ...BillGenError, FirstLvl_printedtype: true });
                            setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                        }
                    }
                    else {
                        document.getElementById('vocherTyp').focus();
                        setBillGenError({ ...BillGenError, FirstLvl_vouchertype: true })
                        setOpen(true); setseverity('warning'); setMessage('Please Select Voucher Type ..!!');
                    }
                }
                else {
                    document.getElementById('PaymentTyp').focus();
                    setBillGenError({ ...BillGenError, FirstLvl_Paymenttype: true })
                    setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                }
            }
            else {
                document.getElementById('paidBy').focus();
                setBillGenError({ ...BillGenError, FirstLvl_BillPayby: true })
                setOpen(true); setseverity('warning'); setMessage('Please Select Bill Paid By ..!!');
            }
        }
        else {
            document.getElementById('billname').focus();
            setBillGenError({ ...BillGenError, FirstLvl_Billname: true });
            setOpen(true); setseverity('warning'); setMessage('Please Select Bill Name ..!!');
        }
        return false;
    }

    const updateCustomBilling = () => {
        if (validate() === true) {
            setUpdateDsa(true);
            setUpdate(true);
            let details = {
                billId: FirstLevelBillValues.billid,
                billName: FirstLevelBillValues.FirstLvl_Billname,
                billAmount: FirstLevelBillValues.FirstLvl_BillAmount,
                billPaidDate: FirstLevelBillValues.FirstLvl_BillPayDate,
                billPaidBy: FirstLevelBillValues.FirstLvl_BillPayby,
                billPaidTo: FirstLevelBillValues.FirstLvl_BillPaidto,
                paymentType: FirstLevelBillValues.FirstLvl_Paymenttype,
                paymentVoucharNo: FirstLevelBillValues.FirstLvl_RecVoucherNo,
                voucherType: FirstLevelBillValues.FirstLvl_vouchertype,
                printedType: FirstLevelBillValues.FirstLvl_printedtype,
                createdBy: getUserId(),
                remarks: FirstLevelBillValues.FirstLvl_Remraks,
                gstprcnt: FirstLevelBillValues.FirstLvl_gstpercnt,
                bill_print_to:FirstLevelBillValues.FirstLvl_BillPrintType
            }
            BillingService.update1stLevelVerification(details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
                } reset();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); reset();
            });
        }
    }

    const deletedOverAllBilling = () => {
        setDeleteDsa(true); setDelete(true);
        BillingService.deletedOverAllBilling(FirstLevelBillValues.billid).then((res) => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setOpen(true); setseverity('success'); setMessage(message);
            } else {
                setOpen(true); setseverity('error'); setMessage('Failed To Delete' + message);
            } reset();
        }).catch(error => {
            setOpen(true); setseverity('error'); setMessage('Failed To Delete' + error.message); reset();
        })
    }

    const refresh = () => {
        setFirstLevelBillValues({
            ...FirstLevelBillValues,
            billid: '', FirstLvl_importer: '', FirstLvl_jobNo: '', FirstLvl_Billname: '', FirstLvl_BillPayby: '', FirstLvl_BillPayDate: '', FirstLvl_BillPaidto: '',
            FirstLvl_Paymenttype: '', FirstLvl_vouchertype: '', FirstLvl_printedtype: '', FirstLvl_RecVoucherNo: '', FirstLvl_BillAmount: '', FirstLvl_Remraks: '', disablejobno: '',
            commercial_invoiceNo: '', generalDesc: '', noofpkgs: '', containerNo: '', besbNo: '', besbDate: '', mawbNo: '', mawbDate: '', hawbNo: '', hawbDate: '', operationType: '',
            accessablevalue: '', grossweight: '', branch: '', importername: '', forwardername: '', servicetype: '', importeriecNo: '', forwarderiecNo: '', Gatewayport: '', FirstLvl_gstpercnt: '',
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
            txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
            lbl_asHawbNo: 'HAWB.No'
        }); setConsigment('');
        setBillGenError({
            ...BillGenError, FirstLvl_Billname: false, FirstLvl_BillPayby: false, FirstLvl_Paymenttype: false, FirstLvl_vouchertype: false,
            FirstLvl_printedtype: false, FirstLvl_RecVoucherNo: false, FirstLvl_BillAmount: false
        });
        setquatetion(''); setexpensis(''); setactualExpensis(''); setrequestEstimetion(''); getData();
        setBillingQuotationDetails([]); setBillingCustodian([]); setPaymentReqPurpose([]); setAllPayment([]); setBillingCustom([]);
        setBillingSummary([]);

        setUpdateDsa(true);
        setUpdate(false);
        setDeleteDsa(true);
        setDelete(false);
    }

    const reset = () => {
        setFirstLevelBillValues({
            ...FirstLevelBillValues,
            billid: '', FirstLvl_importer: '', FirstLvl_jobNo: '', FirstLvl_Billname: '', FirstLvl_BillPayby: '', FirstLvl_BillPayDate: '', FirstLvl_BillPaidto: '',
            FirstLvl_Paymenttype: '', FirstLvl_vouchertype: '', FirstLvl_printedtype: '', FirstLvl_RecVoucherNo: '', FirstLvl_BillAmount: '', FirstLvl_Remraks: '', disablejobno: '',FirstLvl_gstpercnt:'',
            FirstLvl_BillPrintType:'',
            commercial_invoiceNo: '', generalDesc: '', noofpkgs: '', containerNo: '', besbNo: '', besbDate: '', mawbNo: '', mawbDate: '', hawbNo: '', hawbDate: '', operationType: '',
            accessablevalue: '', grossweight: '', branch: '', importername: '', forwardername: '', servicetype: '', importeriecNo: '', forwarderiecNo: '', Gatewayport: ''
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
            txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
            lbl_asHawbNo: 'HAWB.No'
        });
        setBillGenError({
            ...BillGenError, FirstLvl_Billname: false, FirstLvl_BillPayby: false, FirstLvl_Paymenttype: false, FirstLvl_vouchertype: false,
            FirstLvl_printedtype: false, FirstLvl_RecVoucherNo: false, FirstLvl_BillAmount: false
        });
        jobEntryAssign(consigmnt);
        getBillingQuotationDetails(consigmnt);
        getBillingCustodian(consigmnt);
        getPaymentReqPurpose(consigmnt);
        getAllPayment(consigmnt);
        getBillingCustom(consigmnt);
        getBillingSummary(consigmnt);
        setUpdateDsa(true);
        setUpdate(false);
        setDeleteDsa(true);
        setDelete(false);
    }

    const alertBillPreview = () => {
        if (FirstLevelBillValues.besbNo !== '') {
            if (FirstLevelBillValues.besbDate !== '') {
                if (FirstLevelBillValues.accessablevalue !== '' && FirstLevelBillValues.accessablevalue !== '0') {
                    return true;
                }
                else {
                    setError({ ...Error, txt_accValue: true })
                    document.getElementById('billAmount').focus();
                    setOpen(true); setseverity('warning'); setMessage("Accessable Value should not be empty");
                }
            }
            else {
                setError({ ...Error, dat_besbDate: true })
                document.getElementById('billAmount').focus();
                setOpen(true); setseverity('warning'); setMessage("Be/Sb date should not be empty");
            }
        }
        else {
            setError({ ...Error, txt_besbno: true })
            document.getElementById('billAmount').focus();
            setOpen(true); setseverity('warning'); setMessage("Be/Sb no should not be empty");
        }
        return false;
    }

    const updateJobBillPreview = () => {
        if (alertBillPreview() === true) {
            setQuateUpdateDsa(true);
            setQuateUpdate(true);
            var mawbDate, hawbDate, boe_date = '';
            if (FirstLevelBillValues.mawbDate === '') {
                mawbDate = null;
            } else {
                mawbDate = FirstLevelBillValues.mawbDate;
            }
            if (FirstLevelBillValues.hawbDate === '') {
                hawbDate = null;
            } else {
                hawbDate = FirstLevelBillValues.hawbDate;
            }
            if (FirstLevelBillValues.besbDate === '') {
                boe_date = null;
            } else {
                boe_date = FirstLevelBillValues.besbDate;
            }
            let details = {
                consignmentId: consigmnt, MAWBNo: FirstLevelBillValues.mawbNo, mawb_date: mawbDate, hawb_no: FirstLevelBillValues.hawbNo,
                hawbDate: hawbDate, invoiceNumber: FirstLevelBillValues.commercial_invoiceNo, item_description: FirstLevelBillValues.generalDesc,
                noofPkg: FirstLevelBillValues.noofpkgs, containorNo: FirstLevelBillValues.containerNo, boe_no: FirstLevelBillValues.besbNo, boe_date: boe_date,
                accessableValue: FirstLevelBillValues.accessablevalue, gross_wt: FirstLevelBillValues.grossweight, createdBy: getUserId(), branchId: FirstLevelBillValues.branch,
                operationType: FirstLevelBillValues.operationType
            }
            BillingService.updateJobBillPreview(details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
                } DialogQuatetionPartReset();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); DialogQuatetionPartReset();
            })
        }
    }

    const DialogQuatetionPartReset = () => {
        setError({ ...Error, txt_accValue: false, dat_besbDate: false, txt_besbno: false });
        setQuateUpdateDsa(false);
        setQuateUpdate(false);
    }

    const validateQuotation = () => {
        if (radiovalues !== '') {
            return true;
        }
        else {
            setOpen(true); setseverity('warning'); setMessage("Kindly select the Option (Importer or Forwarder)");
        }

        return false;
    }

    const getQuotationBasedOnCustomerType = () => {
        if (validateQuotation() === true) {
            var imp_frwrdr_IecNo, customerType = '';
            if (radiovalues === '1') {
                imp_frwrdr_IecNo = FirstLevelBillValues.importeriecNo;
                customerType = '1'
            } else {
                imp_frwrdr_IecNo = FirstLevelBillValues.forwarderiecNo;
                customerType = '2'

            }
            let details = {
                importerIecNo: imp_frwrdr_IecNo, customerType: customerType, clearanceLocationCode: FirstLevelBillValues.Gatewayport,
                serviceType: FirstLevelBillValues.servicetype
            }
            BillingService.getQuotationBasedOnCustomerType(details).then((res) => {
                setQuotationBasedOnCustomerType(res.data);
            })
        }
    }

    const insertQuotationToBillingTariff = () => {
        if (validateQuotation() === true) {
            if (consigmnt !== '') {
                if (QuotationBasedOnCustomerType !== '') {
                    if (quatetionId.toString() !== '') {

                        let details = { consignmentId: consigmnt, quotationId: quatetionId.toString(), createdBy: getUserId(), customerType: radiovalues }
                        BillingService.insertQuotationToBillingTariff(details).then((res) => {
                            const message = res.data.message;
                            if (message.toString() === 'SUCCESS') {
                                setOpen(true); setseverity('success'); setMessage(message);
                            } else {
                                setOpen(true); setseverity('error'); setMessage('Insertion Failed ' + message);
                            } getBillingQuotationDetails(consigmnt); setOpenQuotationPreview(false);
                        }).catch(error => {
                            setOpen(true); setseverity('error'); setMessage('Insertion Failed ' + error.message); getBillingQuotationDetails(consigmnt); setOpenQuotation(false)
                        })
                    } else {
                        setOpen(true); setseverity('warning'); setMessage("Please Select QuetionId from below Grid");
                    }
                } else {
                    setOpen(true); setseverity('warning'); setMessage("Datagrid should not be empty");
                }
            } else {
                setOpen(true); setseverity('warning'); setMessage("Kindly select the Non Verification Job No");
            }
        }
    }

    const billVerified = () => {
        verifiedFirstBilling();
        updateChargableWeight();
    }

    const verifiedFirstBilling = () => {
        if (consigmnt !== '') {
            let Details = { consignmentId: consigmnt, status: '1', createdBy: getUserId() }
            BillingService.UploadBilling(Details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                    setBillingQuotationDetails([]); setBillingSummary([]); setBillingCustom([]);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Verification Failed ' + message);
                } refresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Verification Failed ' + error.message); refresh();
            })
            setOpenJobBillVerified(false);
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly Select Job No from Right Side Job table');
        }
    }
    const UnVerifiedFirstBilling = () => {
        if (consigmnt !== '') {
            let Details = { consignmentId: consigmnt, status: '5', createdBy: getUserId() }
            BillingService.UploadBilling(Details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                    setBillingQuotationDetails([]); setBillingSummary([]); setBillingCustom([]);
                } else {
                    setOpen(true); setseverity('error'); setMessage('UnVerification Failed ' + message);
                } refresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('UnVerification Failed ' + error.message); refresh();
            })
            setOpenJobBillVerified(false);
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly Select Job No from Right Side Job table');
        }
    }

    const updateChargableWeight = () => {
        let details = { flag: '2', consignmentId: consigmnt, chargeableWeight: dialogValues.chargeableWight }
        BillingService.updateChargableWeight(details).then((res) => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setOpen(true); setseverity('success'); setMessage(message);
            } else {
                setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
            }
        }).catch(error => {
            setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message);
        })
    }


    //onchange 

    const FirstLvl_importerChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        getJobNoConsoleNonUpload(e.target.value, FirstLevelBillValues.FirstLvl_jobNo);
    }
    const FirstLvl_jobNoChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') {
            consigmnt = '-1'
        }
        else {
            consigmnt = e.target.value
        }
        if (FirstLevelBillValues.FirstLvl_importer === '') {
            importer_iec_no = '-1';
        }
        else {
            importer_iec_no = FirstLevelBillValues.FirstLvl_importer;
        }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '16' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => {
            setnonUplode(res.data); setFiltereddetails(res.data)
        });
    }
    const FirstLvl_BillnameChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_Billname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_BillPrintTypeChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_BillPrintType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_BillPaybyChangeHandle = (e) => {
        var totalAmmount = parseFloat(e.target.value)*parseFloat(FirstLevelBillValues.FirstLvl_BillPaidto);
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_BillPayby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ''),FirstLvl_BillAmount:parseFloat(totalAmmount).toFixed(2) })
    }
    const FirstLvl_BillDateChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_BillPayDate: e.target.value })
    }
    const FirstLvl_BillPaidtoChangeHandle = (e) => {
        var totalAmmount = parseFloat(e.target.value)*parseFloat(FirstLevelBillValues.FirstLvl_BillPayby);
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_BillPaidto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ''),FirstLvl_BillAmount:parseFloat(totalAmmount).toFixed(2) })
    }
    const FirstLvl_PaymenttypeChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_Paymenttype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_vouchertypeChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_vouchertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_printedtypeChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_printedtype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_RecVoucherNoChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_RecVoucherNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_BillAmountChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_BillAmount: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_RemraksChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_Remraks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_gstChangeHandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, FirstLvl_gstpercnt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_commercial_invoiceNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, commercial_invoiceNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_generalDescChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, generalDesc: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_noofpkgsChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, noofpkgs: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_containerNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, containerNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_besbNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, besbNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_besbDateChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, besbDate: e.target.value })
    }
    const FirstLvl_mawbNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, mawbNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_mawbDateChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, mawbDate: e.target.value })
    }
    const FirstLvl_hawbNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, hawbNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_hawbDateChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, hawbDate: e.target.value })
    }
    const FirstLvl_accessablevalueChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, accessablevalue: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_grossweightChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, grossweight: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_branchChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_importernameChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, importername: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_forwardernameChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, forwardername: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_servicetypeChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, servicetype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_importeriecNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, importeriecNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_forwarderiecNoChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, forwarderiecNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FirstLvl_GatewayportChangehandle = (e) => {
        setFirstLevelBillValues({ ...FirstLevelBillValues, Gatewayport: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const chargableChangehandle = (e) => {
        setDialogValues({ ...dialogValues, chargeableWight: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    }
    // ...radio onchange....
    const FirstLvl_radioChangehandle = (e) => {
        setradiovalues(e.target.value)
    }

    // ........Dialogbox functions...............

    const CloseQuotationHandle = () => {
        setOpenQuotation(false);
    }
    const OpenQuotationHandle = () => {
        if (consigmnt !== '') {
            setQuotationBasedOnCustomerType([])
            setOpenQuotation(true);
            BillingService.getJobDetailsOperationTypeBillPreview(consigmnt).then((res) => {
                const data = res.data;
                const lastResult = data.map((item) => item);
                let date = lastResult[0].boe_date;
                // const datas = date.split("-");
                // const besbdata = datas[2] + '-' + datas[1] + '-' + datas[0]
                setFirstLevelBillValues({
                    ...FirstLevelBillValues, commercial_invoiceNo: lastResult[0].invoiceNumber, generalDesc: lastResult[0].item_description,
                    noofpkgs: lastResult[0].noofPkg, containerNo: lastResult[0].containorNo, besbNo: lastResult[0].boe_no, besbDate: date,
                    mawbNo: lastResult[0].mawbNo, mawbDate: lastResult[0].mawb_date, hawbNo: lastResult[0].hawb_no, hawbDate: lastResult[0].hawbDate,
                    accessablevalue: lastResult[0].accessableValue, grossweight: lastResult[0].gross_wt, branch: lastResult[0].branchId, operationType: lastResult[0].operationType
                });
            });
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly Select Job.No From Job Table..!!');
        }
    }
    const CloseQuotationPreHandle = () => {
        setOpenQuotationPreview(false);
    }
    const OpenQuotationPreHandle = () => {
        setOpenQuotationPreview(true);
        setSelected([])
        BillingService.getJobDetailsBasedonOperationType(consigmnt).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            setFirstLevelBillValues({
                ...FirstLevelBillValues, Gatewayport: lastResult[0].customHouseCode, importername: lastResult[0].importer_name,
                forwardername: lastResult[0].forwarder_name, importeriecNo: lastResult[0].importer_iec_no, forwarderiecNo: lastResult[0].forwarder_iecNo,
                servicetype: lastResult[0].operationType
            })
        })
    }
    const CloseViewJobHandle = () => {
        setOpenViewJob(false);
    }
    const OpenViewJobHandle = () => {
        setOpenViewJob(true);
    }
    const CloseOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(false);
    }
    const OpenOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(true);
    }

    const CloseJobBillVerifiedHandle = () => {
        setOpenJobBillVerified(false);
    }
    const OpenJobBillVerifiedHandle = () => {
        if (consigmnt !== '') {
            setOpenJobBillVerified(true);
            getJobWeight();
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly select the Non Verification Job No Grid')
        }
    }

    const EditNonUpload = (item) => {
        const selectedIndex = selected2.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected2, item.consignmentNumber);
        }
        setSelected2(newSelected);

        setFirstLevelBillValues({
            ...FirstLevelBillValues,
            billid: '', FirstLvl_importer: '', FirstLvl_jobNo: '', FirstLvl_Billname: '', FirstLvl_BillPayby: '', FirstLvl_BillPayDate: '', FirstLvl_BillPaidto: '',
            FirstLvl_Paymenttype: '', FirstLvl_vouchertype: '', FirstLvl_printedtype: '', FirstLvl_RecVoucherNo: '', FirstLvl_BillAmount: '', FirstLvl_Remraks: '',FirstLvl_gstpercnt:'',
            commercial_invoiceNo: '', generalDesc: '', noofpkgs: '', containerNo: '', besbNo: '', besbDate: '', mawbNo: '', mawbDate: '', hawbNo: '', hawbDate: '', operationType: '',
            accessablevalue: '', grossweight: '', branch: '', importername: '', forwardername: '', servicetype: '', importeriecNo: '', forwarderiecNo: '', Gatewayport: '', disablejobno: item.consignmentNumber,
        });
        setBillingSummary([])
        setBillingCustom([]);
        setConsigment(item.consignmentNumber);
        jobEntryAssign(item.consignmentNumber);
        getBillingQuotationDetails(item.consignmentNumber);
        getBillingCustodian(item.consignmentNumber);
        getPaymentReqPurpose(item.consignmentNumber);
        getAllPayment(item.consignmentNumber);
        getBillingCustom(item.consignmentNumber);
        getBillingSummary(item.consignmentNumber);
    }
    const isSelected = (name) => selected2.indexOf(name) !== -1;

    const assignCustodian = (item) => {
        setUpdateDsa(false);
        setUpdate(false);
        setDeleteDsa(false);
        setDelete(false);
        setFirstLevelBillValues({
            ...FirstLevelBillValues,
            billid: item.billId, FirstLvl_Billname: item.billName,
            FirstLvl_BillPayby: item.unit, FirstLvl_BillPayDate: item.billPaidDate, FirstLvl_BillPaidto: item.rate,FirstLvl_BillPrintType:item.bill_print_to,
            FirstLvl_Paymenttype: item.paymentType, FirstLvl_vouchertype: item.voucherType, FirstLvl_printedtype: item.printedType,
            FirstLvl_RecVoucherNo: item.paymentVoucharNo, FirstLvl_BillAmount: item.billAmount, FirstLvl_Remraks: item.firstLevelRemarks, FirstLvl_gstpercnt:item.gstprcnt
        });
    }

    const getData = async () => {
        BillingService.getnonAudit('16').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
        // BillingService.getAudit('16').then(res => { setconsoleDetails(res.data); });
    }
    const drpData = () => {
        BillingService.getImporterDetails().then((res) => { setDrpImporter(res.data) });
        BillingService.getbillName('-1').then((res) => { setbillName(res.data); });
        BillingService.getBillPaymentType().then((res) => { setbillType(res.data); });
        // BillingService.getBillPaidBy().then((res) => { setBillPrintType(res.data); });
        BillingReportsService.getCurrencyName().then((res) => { setBillPrintType(res.data); });
        BillingService.getVoucherType().then((res) => { setVoucherType(res.data); });
        BillingService.getRegionalOfficeDetails().then((res) => { setBrannch(res.data); });
        BillingService.getPrintedType().then((res) => { setPrintedType(res.data); });
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') {
            consigmnt = '-1'
        }
        else {
            consigmnt = val2
        }
        if (val === '') {
            importer_iec_no = '-1';
        }
        else {
            importer_iec_no = val;
        }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '16' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => {
            setnonUplode(res.data); setFiltereddetails(res.data)
        });
        // BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data); });
    }

    const getBillingQuotationDetails = (val) => {
        BillingService.getBillingQuotationDetails(val).then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i].billAmount;
            }
            setBillingQuotationDetails(res.data);
            setquatetion(billAmnt);
        });
    }
    const getBillingCustodian = (val) => {
        BillingService.getBillingCustodian(val, '-1').then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setBillingCustodian(res.data);
            setexpensis(billAmnt);
        });
    }

    const getPaymentReqPurpose = (val) => {
        let details = { cmId: val, status: '9', requestStatus: 'JOB' }
        BillingService.getPaymentReqPurpose(details).then((res) => {
            const data = res.data;
            const reqAmount = data.map((item) => item.reqAmount);
            let reqAmnt = 0;
            for (let i = 0; i < reqAmount.length; i++) {
                reqAmnt += reqAmount[i];
            }
            setPaymentReqPurpose(res.data);
            setrequestEstimetion(reqAmnt);
        });
    }

    const getAllPayment = (val) => {
        BillingService.getAllPayment(val, '-1').then((res) => {
            const data = res.data;
            const tspAmt = data.map((item) => item.tspAmt);
            let tsp = 0;
            for (let i = 0; i < tspAmt.length; i++) {
                tsp += tspAmt[i];
            }
            setAllPayment(res.data);
            setactualExpensis(tsp)
        })
    }

    const getBillingCustom = (val) => {
        BillingService.getBillingCustom(val, '-1').then((res) => {
            setBillingCustom(res.data);
        })
    }

    const getBillingSummary = (val) => {
        BillingService.getBillingSummary(val).then((res) => {
            setBillingSummary(res.data)
        })
    }

    const jobEntryAssign = (val) => {
        BillingService.getJobDetailsAssign(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress,
                txt_asTransitType: lastResult[0].transitTypeName, txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName,
                txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName, txt_asArrivalDate: lastResult[0].expectedArrivalDateTime,
                txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            })
        });
    }

    const getJobWeight = () => {
        BillingService.getJobWeight(1, consigmnt).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            setDialogValues({ ...dialogValues, grossWight: lastResult[0].weightIdString, chargeableWight: lastResult[0].chargeableWeight });
        })
    }

    useEffect(() => {
        setloading(true)
        setTimeout(() => {
            setloading(false)
        }, 1000)
        const getData = async () => {
            BillingService.getnonAudit('16').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
            // BillingService.getAudit('16').then(res => { setconsoleDetails(res.data); });
        }
        getData();
        drpData();
    }, []);

    const AllMAWBHandle = (event) => {
        if (event.target.checked) {
            const ALLMawb = QuotationBasedOnCustomerType.map((n) => n.customTariffID);
            setSelected(ALLMawb);
            console.log("eeb = " + ALLMawb);
            setQuatetionId(ALLMawb)
            return;
        }
        setSelected([]);
    };

    const SlectedMAWBClick = (event, customTariffID) => {
        const selectedIndex = selected.indexOf(customTariffID);
        let SelectedMawb = [];

        if (selectedIndex === -1) {
            SelectedMawb = SelectedMawb.concat(selected, customTariffID);
            console.log("===-1 " + SelectedMawb)
            setQuatetionId(SelectedMawb)
        }
        else if (selectedIndex === 0) {
            SelectedMawb = SelectedMawb.concat(selected.slice(1));
            console.log(" " + SelectedMawb)
            setQuatetionId(SelectedMawb)
        }
        else if (selectedIndex === selected.length - 1) {
            SelectedMawb = SelectedMawb.concat(selected.slice(0, -1));
            console.log("length-1 " + SelectedMawb)
            setQuatetionId(SelectedMawb)
        }
        else if (selectedIndex > 0) {
            SelectedMawb = SelectedMawb.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1),);
            console.log(">0 " + SelectedMawb)
            setQuatetionId(SelectedMawb)
        }

        setSelected(SelectedMawb);
    };

    const isMAWBSelected = (customTariffID) => selected.indexOf(customTariffID) !== -1;

    //handleClose/open
    const handleClose = () => {
        setOpen(false);
    }
    //table search
    const jobNosrch = () => {
        return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { jobNoOnChange(e.target.value) }} placeholder="Search" />
    }
    const jobNoOnChange = (searchedVal) => {
        const FilterValues = nonUplode.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setFiltereddetails(nonUplode)
        } else {
            setFiltereddetails(FilterValues)
        }
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/conslBills');
    }
    const ForwordBotton = () => {
        navigate('/2ndlvl');
    }
    return (
        <div>
            <Home />
            <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <div style={{ paddingLeft: '100px' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <div>
                    <Dialog open={OpenQuotation} onClose={CloseQuotationHandle} fullWidth={true} maxWidth='md'>
                        {/*  */}
                        <Dialog open={OpenQuotationPreview} onClose={CloseQuotationPreHandle} fullWidth={true} maxWidth='md'>
                            <DialogTitle className='p-1 ' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center>Billing From Quotation Part</center></DialogTitle>
                            <DialogContent>
                                <Row className='mt-3'>
                                    <Col xs={2}>Importer Name</Col>
                                    <Col><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.importername} onChange={FirstLvl_importernameChangehandle} /></Col>
                                    <Col xs={2}>Importer IecNo</Col>
                                    <Col><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.importeriecNo} onChange={FirstLvl_importeriecNoChangehandle} /></Col>
                                </Row>
                                <Row className='mt-1'>
                                    <Col xs={2}>Forwarder Name</Col>
                                    <Col><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.forwardername} onChange={FirstLvl_forwardernameChangehandle} /></Col>
                                    <Col xs={2}>Forwarder IecNo</Col>
                                    <Col><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.forwarderiecNo} onChange={FirstLvl_forwarderiecNoChangehandle} /></Col>
                                </Row>
                                <Row className='mt-1'>
                                    <Col xs={2}>Service Type</Col>
                                    <Col ><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.servicetype} onChange={FirstLvl_servicetypeChangehandle} /></Col>
                                    <Col xs={2}>Gate Way Port</Col>
                                    <Col ><Form.Control size='sm' style={{ border: '1px solid black' }} disabled
                                        value={FirstLevelBillValues.Gatewayport} onChange={FirstLvl_GatewayportChangehandle} /></Col>
                                </Row>
                                <ItemPap1 className='mt-1'>
                                    <Row className='form-inline'>
                                        <Col xs={3}><label style={{ fontWeight: 'bolder', color: 'black' }}>Select Billing Customer</label></Col>
                                        <Col xs={3}><Form.Check inline label="Importer/Exporter" type={'radio'} checked={radiovalues === '1'} value='1' onChange={FirstLvl_radioChangehandle} /></Col>
                                        <Col xs={1}><Form.Check inline label="Forwarder" type={'radio'} checked={radiovalues === '2'} value='2' onChange={FirstLvl_radioChangehandle} /></Col>
                                        <Col><Button variant='contained' style={{ fontFamily: 'Times New Roman' }} size='small' onClick={getQuotationBasedOnCustomerType}>Search</Button>{' '}
                                            <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} size='small' onClick={insertQuotationToBillingTariff}>Go To Billing</Button></Col>
                                    </Row>
                                </ItemPap1>
                                <Paper sx={{ height: 279 }}>
                                    <TableContainer sx={{ maxHeight: 279 }} className='scrollbarPrime'>
                                        <Table stickyHeader className='table table-bordered'>
                                            <TableHead >
                                                <StyledTableRow>
                                                    <StyledTableCell className='p-1' padding="checkbox">
                                                        <Checkbox className='p-1'
                                                            indeterminate={selected.length}
                                                            checked={selected.length}
                                                            onChange={AllMAWBHandle}
                                                            inputProps={{ 'aria-label': 'select all desserts' }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                                    <StyledTableCell className='p-1' >Charges_Name</StyledTableCell>
                                                    <StyledTableCell className='p-1'>UOM</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Minimum_Amount</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Max_Amount</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Assessable_Value</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Customer_Name</StyledTableCell>
                                                    <StyledTableCell className='p-1'>GateWay_Port</StyledTableCell>
                                                    <StyledTableCell className='p-1'>GateWay_Code</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Transit_Type</StyledTableCell>
                                                    <StyledTableCell className='p-1'>IEC_Code</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Service_Type</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {QuotationBasedOnCustomerType.map((item) => {
                                                    const checkSelcted = isMAWBSelected(item.customTariffID);
                                                    return (
                                                        <StyledTableRow hover key={item.customTariffID} onClick={(event) => SlectedMAWBClick(event, item.customTariffID)}
                                                            role="checkbox" aria-checked={checkSelcted} tabIndex={-1} selected={checkSelcted}>
                                                            <StyledTableCell className='p-1' padding="checkbox">
                                                                <Checkbox className='p-1' checked={checkSelcted} />
                                                            </StyledTableCell>
                                                            <StyledTableCell width='5px'>{item.serialNumber}</StyledTableCell>
                                                            <StyledTableCell>{item.itemName}</StyledTableCell>
                                                            <StyledTableCell>{item.unitCode}</StyledTableCell>
                                                            <StyledTableCell>{item.minimumCharge}</StyledTableCell>
                                                            <StyledTableCell>{item.amtPerUnit}</StyledTableCell>
                                                            <StyledTableCell>{item.maximumUnit}</StyledTableCell>
                                                            <StyledTableCell>{item.importerName}</StyledTableCell>
                                                            <StyledTableCell>{item.gatewayPortCode}</StyledTableCell>
                                                            <StyledTableCell>{item.gatewayPortName}</StyledTableCell>
                                                            <StyledTableCell>{item.transitTypeName}</StyledTableCell>
                                                            <StyledTableCell>{item.iecNo}</StyledTableCell>
                                                            <StyledTableCell>{item.serviceType}</StyledTableCell>
                                                        </StyledTableRow>)
                                                }
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </DialogContent>
                        </Dialog>

                        {/* Billing From Quotation Part  */}
                        <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center>Billing From Quotation Part</center></DialogTitle>
                        <DialogContent>
                            <lable style={{ fontSize: '15px', fontWeight: 'bold', color: 'red', marginBottom: '1%' }}>JOB ENTRY DETAILS</lable>
                            <Row>
                                <Col xs={3}>
                                    <Row><label style={{ marginBottom: '5%', marginTop: '4%' }}>Commercial Invoice No</label></Row>
                                    <Row><label style={{ marginBottom: '5%' }}>General Description</label></Row>
                                    <Row><label style={{ marginBottom: '5%' }}>No of Pkgs</label></Row>
                                    <Row><label style={{ marginBottom: '5%' }}>Container No</label></Row>
                                    <Row><label style={{ marginBottom: '5%' }}>BE/SB No</label></Row>
                                    <Row><label style={{ marginBottom: '5%' }}>BE/SB Date</label></Row>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='InvoiceNo'
                                        value={FirstLevelBillValues.commercial_invoiceNo} onChange={FirstLvl_commercial_invoiceNoChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='descTion'
                                        value={FirstLevelBillValues.generalDesc} onChange={FirstLvl_generalDescChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='noOfPkgs'
                                        value={FirstLevelBillValues.noofpkgs} onChange={FirstLvl_noofpkgsChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='ContainerNo'
                                        value={FirstLevelBillValues.containerNo} onChange={FirstLvl_containerNoChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='beSbNo'
                                        value={FirstLevelBillValues.besbNo} onChange={FirstLvl_besbNoChangehandle} isInvalid={Error.txt_besbno} />
                                    <Form.Control size='sm' className='mt-1' type='date' style={{ border: '1px solid black', textAlign: 'center' }} id='beSbDate'
                                        value={FirstLevelBillValues.besbDate} onChange={FirstLvl_besbDateChangehandle} isInvalid={Error.dat_besbDate} />
                                </Col>
                                <Col xs={2}>
                                    <Row><label style={{ marginBottom: '7%', marginTop: '6%' }}>MAWB No</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>MAWB Date</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>HAWB No</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>HAWB Date</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>Assessable Value</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>Gross Weight</label></Row>
                                    <Row><label style={{ marginBottom: '7%' }}>Branch</label></Row>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='mawbNo'
                                        value={FirstLevelBillValues.mawbNo} onChange={FirstLvl_mawbNoChangehandle} />
                                    <Form.Control size='sm' className='mt-1' type='date' style={{ border: '1px solid black', textAlign: 'center' }} id='mawbDate'
                                        value={FirstLevelBillValues.mawbDate} onChange={FirstLvl_mawbDateChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='hawbNo'
                                        value={FirstLevelBillValues.hawbNo} onChange={FirstLvl_hawbNoChangehandle} />
                                    <Form.Control size='sm' className='mt-1' type='date' style={{ border: '1px solid black', textAlign: 'center' }} id='hawbDate'
                                        value={FirstLevelBillValues.hawbDate} onChange={FirstLvl_hawbDateChangehandle} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='assValue'
                                        value={FirstLevelBillValues.accessablevalue} onChange={FirstLvl_accessablevalueChangehandle} isInvalid={Error.txt_accValue} />
                                    <Form.Control size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='grossWight'
                                        value={FirstLevelBillValues.grossweight} onChange={FirstLvl_grossweightChangehandle} />
                                    <Form.Select size='sm' className='mt-1' style={{ border: '1px solid black', textAlign: 'center' }} id='branch'
                                        value={FirstLevelBillValues.branch} onChange={FirstLvl_branchChangehandle}>
                                        <option value={''}> </option>
                                        {Brannch.map((item) => (
                                            <option value={item.regionalOfficeId}>{item.regionalName}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Row>
                            <div className='mt-1'><center>
                                <Button style={{ fontFamily: 'Times New Roman' }} variant='contained' onClick={updateJobBillPreview} disabled={QuateUpdateDsa}>{QuateUpdate ? 'processing...' : 'Update'}</Button>
                                <Button style={{ fontFamily: 'Times New Roman', marginLeft: '1%' }} variant='contained' onClick={OpenQuotationPreHandle}>Preview Verified</Button>
                            </center></div>
                        </DialogContent>
                    </Dialog>
                    {/* view Job */}
                    <Dialog open={OpenViewJob} onClose={CloseViewJobHandle} fullWidth={true} maxWidth='lg'>
                        <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center>Job Entry Details</center></DialogTitle>
                        <Paper sx={{ height: 250 }}>
                            <Row className='mt-1'>
                                <Col className='jobentrAssign' xs={4}>
                                    <Row xs={5} className='p-2'>
                                        <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                        <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={5}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asMawbNo}</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                        <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                        <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                        <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                                    </Row>
                                </Col>

                                <Col className='jobentrAssign'>
                                    <Row xs={5} className='p-1'>
                                        <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                        <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asAirlinesName}</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                                    </Row>
                                </Col>
                                <Col className='jobentrAssign'>
                                    <Row xs={5} className='p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                                    </Row>
                                    <Row xs={5} className='mt-2 p-1'>
                                        <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asHawbNo}</label></Col>
                                        <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Paper>
                    </Dialog>
                    {/*  */}
                    <Dialog open={OpenOverAllViewJob} onClose={CloseOverAllViewJobHandle} fullWidth={true} maxWidth='md'>
                        <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center>Over All Bill Details</center></DialogTitle>
                        <DialogContent>
                            <Paper sx={{ height: 279 }}>
                                <TableContainer sx={{ maxHeight: 279, marginTop: '2%' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1'>Description</StyledTableCell>
                                                <StyledTableCell className='p-1'>Amount</StyledTableCell>
                                                <StyledTableCell className='p-1'>PaidBy</StyledTableCell>
                                                <StyledTableCell className='p-1'>Bill Paid Date</StyledTableCell>
                                                <StyledTableCell className='p-1'>Payment Type</StyledTableCell>
                                                <StyledTableCell className='p-1'>Voucher Type</StyledTableCell>
                                                <StyledTableCell className='p-1'>Printed Type</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingCustom.map((item) => (
                                                <StyledTableRow hover key={item.serialNumber} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                    <StyledTableCell>{item.billPaidBy}</StyledTableCell>
                                                    <StyledTableCell>{item.billPaidDate}</StyledTableCell>
                                                    <StyledTableCell>{item.paymentType}</StyledTableCell>
                                                    <StyledTableCell>{item.voucherType}</StyledTableCell>
                                                    <StyledTableCell>{item.printedType}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </DialogContent>
                    </Dialog>
                    {/* billVerified */}
                    <Dialog open={OpenJobBillVerified} onClose={CloseJobBillVerifiedHandle} fullWidth={true} maxWidth='sm'>
                        <DialogTitle className='p-1 bg-info' style={{ fontWeight: 'bolder' }}><center>Chargeable Weight Updation</center></DialogTitle>
                        <div className='bg-light mt-2'>
                            <center><TextField size='small' className='mt-1' label='Gross Wight' aria-readonly value={dialogValues.grossWight} /></center>
                            <center><TextField size='small' className='mt-2' label='Chargeable Wight' value={dialogValues.chargeableWight}
                                onChange={chargableChangehandle} /></center>
                            <br></br>
                            <center><Button style={{ fontFamily: 'Times New Roman' }} variant='contained' size='small' onClick={billVerified}>Bill Verified</Button></center>
                            <br></br>
                            <Divider />
                        </div>
                    </Dialog>
                </div>
                {loading ?
                    <div className="loaderCss">
                        <HashLoader
                            color={"#296cbc"}
                            loading={loading}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    <Grid container>
                        <Grid item xs={2}>
                            <ItemPap3 >
                                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt'  size="small" >
                             <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                                <lable style={{ fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginLeft: '18px' }}>NON VERIFICATION JOB</lable>
                                <TableContainer sx={{ maxHeight: 360 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1'>JobNo {jobNosrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Filtereddetails.map((item) => {
                                                const isItemSelected = isSelected(item.consignmentId);
                                                return (
                                                    <TableRow hover key={item.consignmentNumber} tabIndex={-1} selected={isItemSelected} onClick={() => EditNonUpload(item)}>
                                                        <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.consignmentNumber}</StyledTableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap3>
                        </Grid>
                        <Grid item xs={7}>
                            <ItemPap>
                                <div className=' p-1 mt-2 mb-2'>
                                    <Row>
                                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '1%' }}>FIRST LEVEL BILL VERIFICATION</lable>
                                        <Col xs={1}>
                                            <label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>JOB.NO</label>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' onKeyDown={searchkeydown}
                                                id='jobno' value={FirstLevelBillValues.FirstLvl_jobNo} onChange={FirstLvl_jobNoChangeHandle} />
                                        </Col>
                                        <Col xs={2}><label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>IMPORTER</label></Col>
                                        <Col xs={3}>
                                            <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                                value={FirstLevelBillValues.FirstLvl_importer} onChange={FirstLvl_importerChangeHandle} >
                                                <option value={''}></option>
                                                {DrpImporter.map((item) => (
                                                    <option value={item.importer_iec_no}>{item.importer_name}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col xs={1}>
                                            <label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder', textAlign: 'center' }}>JOB.NO</label>
                                        </Col>
                                        <Col xs={2}>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', color: 'darkred', textAlign: 'center', fontWeight: 'bold' }} value={FirstLevelBillValues.disablejobno} disabled />
                                        </Col>
                                    </Row>
                                </div>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Bill Name</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_Billname} disabled
                                         id='billname' required value={FirstLevelBillValues.FirstLvl_Billname} onChange={FirstLvl_BillnameChangeHandle}>
                                            <option value={''}></option>
                                            {billName.map((item) => (
                                                <option value={item.billName}>{item.billName}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Payment Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_Paymenttype}
                                        tabIndex={5} id='PaymentTyp' required value={FirstLevelBillValues.FirstLvl_Paymenttype} onChange={FirstLvl_PaymenttypeChangeHandle}>
                                            <option value={''}></option>
                                            {billType.map((item) => (
                                                <option value={item.paymentType}>{item.paymentType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label className='billingIpTitle'>Rec_VoucherNo</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                        tabIndex={9} id='voucerNo' value={FirstLevelBillValues.FirstLvl_RecVoucherNo} onChange={FirstLvl_RecVoucherNoChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Curruncy</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_BillPayby}
                                        tabIndex={1} id='paidBy' required value={FirstLevelBillValues.FirstLvl_BillPrintType} onChange={FirstLvl_BillPrintTypeChangeHandle}>
                                            <option value=''></option>
                                            {billPrintType.map((item) => (
                                                <option value={item.currency_code}>{item.currency_code}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Voucher Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_vouchertype}
                                        tabIndex={6} id='vocherTyp' required value={FirstLevelBillValues.FirstLvl_vouchertype} onChange={FirstLvl_vouchertypeChangeHandle}>
                                            <option value={''}></option>
                                            {VoucherType.map((item) => (
                                                <option value={item.voucherType}>{item.voucherType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={4}><label className='billingIpTitle'>BillPaid Date</label>
                                        <Form.Control type='date' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                    tabIndex={10} id='billpaidDate' required value={FirstLevelBillValues.FirstLvl_BillPayDate} onChange={FirstLvl_BillDateChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label  style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }} >Unit Price</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                    tabIndex={3}  id='paidto' value={FirstLevelBillValues.FirstLvl_BillPayby} onChange={FirstLvl_BillPaybyChangeHandle} />
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Printed Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_printedtype}
                                     tabIndex={7} id='printedTyp' required value={FirstLevelBillValues.FirstLvl_printedtype} onChange={FirstLvl_printedtypeChangeHandle}>
                                            <option value={''}></option>
                                            {PrintedType.map((item) => (
                                                <option value={item.printedType}>{item.printedType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Bill Amount</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} isInvalid={BillGenError.FirstLvl_BillAmount}
                                    tabIndex={11} id='billAmount' required value={FirstLevelBillValues.FirstLvl_BillAmount} onChange={FirstLvl_BillAmountChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'Red', fontWeight: 'bolder' }}>Rate</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                    tabIndex={4} id='paidto' value={FirstLevelBillValues.FirstLvl_BillPaidto} onChange={FirstLvl_BillPaidtoChangeHandle} />
                                    </Col>
                                    <Col className='mt-1 mb-1'>
                                        <label className='billingIpTitle'>Remarks</label>
                                        <center><Form.Control style={{ border: '1px solid black', height: '26px', width: '257px', textAlign: 'center', fontWeight: 'bold' }}
                                    tabIndex={8} id='rmark' value={FirstLevelBillValues.FirstLvl_Remraks} onChange={FirstLvl_RemraksChangeHandle} /></center>
                                    </Col>
                                    <Col>
                                        <label className='billingIpTitle'>Gst(%)</label>
                                        <center>< Form.Control id='gstid' style={{ border: '1px solid black', height: '26px', width: '257px', textAlign: 'center', fontWeight: 'bold' }}
                                    tabIndex={12} value={FirstLevelBillValues.FirstLvl_gstpercnt} onChange={FirstLvl_gstChangeHandle} /></center>
                                    </Col>
                                </Row>
                                <div className='mt-2 form-inline'>
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={updateCustomBilling} disabled={UpdateDsa}>{Update ? 'processing..' : 'Update'}</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={deletedOverAllBilling} disabled={DeleteDsa}>{Delete ? 'processing..' : 'Delete'}</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={refresh}>Refresh</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={OpenViewJobHandle}>View_Job</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={OpenOverAllViewJobHandle}>View Over All Bill</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={OpenQuotationHandle}>Billing_From_Quotation</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={OpenJobBillVerifiedHandle}>Bill_Verified</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' onClick={UnVerifiedFirstBilling}>Un Verified_Payment_Approval</Button>{' '}
                                </div>
                            </ItemPap>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap4 >
                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginRight: '50px' }}>SUMMARY DETAILS</lable>
                                {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
                                <TableContainer sx={{ maxHeight: 360 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }} >Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingSummary.map((item) => (
                                                <StyledTableRow hover key={item.billType}>
                                                    <StyledTableCell>{item.billType}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap4>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >Billing Amount From Quotation:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{quatetion}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingQuotationDetails.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >Billing Amount From Expenses:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{expensis}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingCustodian.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >Actual/Expenses Amount:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{actualExpensis}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {AllPayment.map((item) => (
                                                <StyledTableRow hover key={item} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.tspPaidTo}</StyledTableCell>
                                                    <StyledTableCell>{item.tspAmt}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >Request/Estimation Amount:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{requestEstimetion}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {PaymentReqPurpose.map((item) => (
                                                <StyledTableRow hover key={item.reqPurpose} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell>{item.reqAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                    </Grid>}
            </div>
        </div >
    )
}

export default FirstLevelBill